import { Route, Routes } from "react-router-dom";
import { AdminGate } from "@/components/AdminGate";
import { AuthGate } from "@/components/AuthGate";
import { Layout } from "@/components/Layout";
import { MemberGate } from "@/components/MemberGate";
import { SurveysGate } from "@/components/SurveysGate";
import { AdminPage } from "@/routes/AdminPage";
import { HomePage } from "@/routes/HomePage";
import { LaunchesPage } from "@/routes/LaunchesPage";
import { LaunchPage } from "@/routes/LaunchPage";
import { OpinionsPage } from "@/routes/OpinionsPage";
import { PreferencesPage } from "@/routes/PreferencesPage";
import { PreferencesTopicPage } from "@/routes/PreferencesTopicPage";
import { SkillsPage } from "@/routes/SkillsPage";
import { SystemsPage } from "@/routes/SystemsPage";

/**
 * Routes render inside the branded Layout shell, behind the MSAL AuthGate.
 * Three surfaces are open to everyone: ``/systems`` (Current Systems — the
 * factual layer), ``/preferences`` (Surveys — the agentic interview, which
 * is the one thing we want people doing) and ``/launches`` (published launch
 * films, made to be shared). Surveys sit behind ``SurveysGate``: a deployment
 * can switch the page off (``SURVEYS_ON_THE_WEB``, off since 2026-10-12) and
 * leave the interview to a Claude client.
 *
 * ``/opinions`` (team positions), ``/skills`` (the catalog) and ``/admin``
 * (interview session moderation) sit behind ``AdminGate``: the aggregate isn't
 * the team-visible layer until the interviews have actually run. The gate
 * redirects non-admins to "/" so a hand-typed URL degrades instead of 403-ing
 * in the UI; the API enforces admin on its own controls regardless. The M3
 * admin chat wraps the same way.
 *
 * The Leadership Team signs in with the ``Launcher.Only`` app role and gets
 * ``/launches`` only: every other route sits under ``MemberGate``, which sends
 * them there. A new route belongs under it unless Leadership should see it.
 */
export function App() {
  return (
    <AuthGate>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/launches" element={<LaunchesPage />} />
          <Route path="/launches/:videoId" element={<LaunchPage />} />
          <Route element={<MemberGate />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/systems" element={<SystemsPage />} />
            <Route
              path="/preferences"
              element={
                <SurveysGate>
                  <PreferencesPage />
                </SurveysGate>
              }
            />
            <Route
              path="/preferences/:topic"
              element={
                <SurveysGate>
                  <PreferencesTopicPage />
                </SurveysGate>
              }
            />
            <Route
              path="/opinions"
              element={
                <AdminGate>
                  <OpinionsPage />
                </AdminGate>
              }
            />
            <Route
              path="/skills"
              element={
                <AdminGate>
                  <SkillsPage />
                </AdminGate>
              }
            />
            <Route
              path="/admin"
              element={
                <AdminGate>
                  <AdminPage />
                </AdminGate>
              }
            />
          </Route>
        </Route>
      </Routes>
    </AuthGate>
  );
}
